import script from "./Step2OTPVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2OTPVerification.vue?vue&type=script&setup=true&lang=js"

import "./Step2OTPVerification.vue?vue&type=style&index=0&id=e957198c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e957198c"]])

export default __exports__